export enum ModalMainTypes {
  Add = 'Add',
  Edit = 'Edit',
}
